import { render, staticRenderFns } from "./meetingMinutes.vue?vue&type=template&id=e2f81970&scoped=true&"
import script from "./meetingMinutes.vue?vue&type=script&lang=js&"
export * from "./meetingMinutes.vue?vue&type=script&lang=js&"
import style0 from "./meetingMinutes.vue?vue&type=style&index=0&id=e2f81970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f81970",
  null
  
)

export default component.exports